import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import PsContext from "../../context";
import { _LIST_CONTENTS } from "../../models/fieldSettings";
import { cdnFileLink } from "../../utils";

const AlumniList = (props) => {
  const context = useContext(PsContext);

  const [dataList, setDataList] = useState([]);

  const field = (fieldName) => props?.dataSource?.[fieldName];

  const [windowSize, setWindowSize] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      // Perform actions on window resize
      //setWindowSize([window.innerWidth, window.innerHeight]);
      setWindowSize(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setWindowSize(window.innerWidth);
    loadData();
  }, []);

  const loadData = () => {
    _LIST_CONTENTS({
      type: "alumni",
      limit: 20,
      order_by: "row_order ASC",
    }).then((res) => {
      if (res.status == "1") {
        setDataList(res.data);
      }
    });
  };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: windowSize && windowSize < 500 ? 1 : 4,
    slidesToScroll: windowSize && windowSize < 500 ? 1 : 4,
    autoplay: true,
  };

  const getCard = (item) => {
    return (
      <div className="home-top-cour">
        <Card className="border-0 rounded mx-3 h-100 alumni-card mover">
          <Card.Body className="text-center">
            <img
              className="w-100 rounded"
              style={{ height: "250px" }}
              src={cdnFileLink(item.feature_image)}
              alt=""
            />
            <div
              style={{
                fontSize: "13px",
              }}
            >
              <div
                style={{ fontSize: "16px", fontWeight: "700" }}
                className="fw-bold pb-2 mt-2"
              >
                {item.title}
              </div>
              <div
                className="text-muted mb-2"
                style={{ fontSize: "15px", fontWeight: "700" }}
              >
                {item.category}
              </div>
              {item.content_html && (
                <div
                  style={{ fontSize: "12px", color: "#000", fontWeight: "500" }}
                >
                  {item.content_html}
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  };

  return (
    <>
      <section
        className="py-4"
        style={{ backgroundColor: field("bgColor") || "#fff" }}
      >
        <div
          className="container mb-4"
          style={{ backgroundColor: field("bgColor") || "#fff" }}
        >
          <h4
            className="text-center mb-5 text-theme heading-with-underline py-4"
            // style={{ color: field("textColor") || "black" }}
          >
            {field("pageTitle") || "Illustrious Alumni"}
          </h4>
          <Slider {...settings}>
            {dataList.map(
              (item, i) => item.show_on_top_scroll == "1" && getCard(item, i)
            )}
          </Slider>
        </div>
      </section>
    </>
  );
};

export default AlumniList;
